module.exports = __webpack_public_path__ + "img/flower-chen.8212a7aa.jpg";